// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"8b92ee8b","834":"13170176"}[chunkId] + ".chunk.js";
};